module.exports = __webpack_public_path__ + "img/me.9d2cf1b7.svg";